exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-landing-page-ghost-jsx": () => import("./../../../src/pages/LandingPageGhost.jsx" /* webpackChunkName: "component---src-pages-landing-page-ghost-jsx" */)
}

